import {Component, input} from '@angular/core';
import {TodoPriorityId, TodoPrioritySelect} from '../../../../../api';
import {ElciaIcon} from '../../../../components/icon/icon';

@Component({
  selector: 'elcia-todo-priority-indicator',
  imports: [
    ElciaIcon
  ],
  templateUrl: './todo-priority-indicator.component.html',
  styleUrl: './todo-priority-indicator.component.scss',
})
export class TodoPriorityIndicator {
  priority = input.required<TodoPrioritySelect>();
  priorityEnum = TodoPriorityId;

}
